import { useContext } from "react";
import SelectController from "../../../../../../core/ui/components/SelectController";
import useUser from "../../../../../../core/hooks/use-user";
import CuadroTurnosContext from "../../../../store/cuadro-turnos-context";
import SelectsFiltrosCuadrosTurnosContext from "../../../../store/selects-filtros-cuadros-turnos-context";
import { useForm } from "react-hook-form";
import { useEffect } from "react";

export default function SelectSubAreasLider() {
    const { getUserData } = useUser();
    const user = getUserData();
    const { areaId, subAreas, setSubAreas } = useContext(
        SelectsFiltrosCuadrosTurnosContext
    );
    const { setFiltros } = useContext(CuadroTurnosContext);

    const subAreasUsuario = user.sub_areas.reduce((prev, subArea) => {
        if (
            !Object.prototype.hasOwnProperty.call(prev, subArea.id) &&
            subArea.area_id == areaId
        ) {
            prev[subArea.id] = {
                label: subArea.nombre,
                value: subArea.id,
            };
        }
        return prev;
    }, {});

    const options = Object.values(subAreasUsuario);


    const {
        control,
        setValue,
        formState: { errors },
    } = useForm({
        defaultValues: { subAreasLider: null },
    });

    useEffect(() => {
        const subAreasLider = options.filter((sa) => subAreas.includes(sa.value));
        setValue("subAreasLider", subAreasLider);
    }, [subAreas])

    const onChangeSubAreaLider = (subAreas) => {
        subAreas ??= [];
        const subAreasFiltro = subAreas.map((subArea) => {
            return subArea.value;
        });

        setSubAreas(subAreasFiltro);
        setFiltros((prev) => {
            return { ...prev, subAreasLider: subAreasFiltro };
        });
    };

    return (
        <div>
            <label className="mt-2">
                <i className="fas fa-sort-amount-down-alt"></i> Sub Areas
            </label>
            <form>
                <SelectController
                    control={control}
                    errors={errors}
                    name="subAreasLider"
                    onChange={onChangeSubAreaLider}
                    isMulti={true}
                    zIndex={200}
                    options={options}
                />
            </form>
        </div>
    );
}
